import { styled as styledMaterial } from '@mui/material/styles'
import { Stack } from '@mui/material'

export const ContentPaths = styledMaterial(Stack)(() => ({
  a: { textDecoration: 'none' },
}))
